
import {
  Vue, Component, Prop, Ref, Watch,
} from 'vue-property-decorator';
import { requiredRules } from '@/features/common/helpers/validationRules';
import { VForm } from '@/features/common/types';

const COOLDOWN_SECONDS = 30;

@Component
export default class FedExPinStep extends Vue {
  @Ref('form') form!: VForm;

  @Prop({ default: false }) loading!: boolean;

  @Prop({ default: false }) resending!: boolean;

  @Prop({ default: false }) resendSuccess!: boolean;

  private pin = '';

  private resendConfirm = false;

  private cooldownSeconds = 0;

  private cooldownInterval: number | null = null;

  private confirmTimer: number | null = null;

  private pinRules = [
    ...requiredRules,
    (v: string) => /^\d{6}$/.test(v) || this.$t('carrierAccounts.fedexRegistration.pin.invalidFormat'),
  ];

  get isOnCooldown(): boolean {
    return this.cooldownSeconds > 0;
  }

  mounted(): void {
    this.startCooldown();
  }

  @Watch('resendSuccess')
  private onResendSuccess(val: boolean): void {
    if (!val) return;

    this.resendConfirm = true;
    if (this.confirmTimer) clearTimeout(this.confirmTimer);
    this.confirmTimer = window.setTimeout(() => {
      this.resendConfirm = false;
    }, 2000);

    this.startCooldown();
  }

  private startCooldown(): void {
    if (this.cooldownInterval) clearInterval(this.cooldownInterval);
    this.cooldownSeconds = COOLDOWN_SECONDS;
    this.cooldownInterval = window.setInterval(() => {
      this.cooldownSeconds -= 1;
      if (this.cooldownSeconds <= 0 && this.cooldownInterval) {
        clearInterval(this.cooldownInterval);
        this.cooldownInterval = null;
      }
    }, 1000);
  }

  private onKeypress(event: KeyboardEvent): void {
    if (!/^\d$/.test(event.key) || this.pin.length >= 6) {
      event.preventDefault();
    }
  }

  private onSubmit(): void {
    if (!this.form.validate()) return;
    this.$emit('submit', this.pin);
  }

  beforeDestroy(): void {
    if (this.confirmTimer) clearTimeout(this.confirmTimer);
    if (this.cooldownInterval) clearInterval(this.cooldownInterval);
  }
}
